module.exports = __webpack_public_path__ + "static/media/281.41449cd7.svg";